<template>
    <div class="form-item__checkbox form-checkbox">
        <input type="checkbox" v-model="model" v-bind="({ name, placeholder } = inputProps)" :id="name" />
        <span :class="checkboxIconClass">{{ checkboxIcon }}</span>
    </div>
</template>

<script>
import { proxyModelMixin } from '@/mixins/proxyModelMixin';
export default {
    name: 'input-checkbox',
    props: {
        modelValue: { type: String, default: '' },
        name: { type: String, default: '' },
        group: { type: String, default: null },
        placeholder: { type: String, default: '' },
    },
    mixins: [proxyModelMixin],
    computed: {
        inputProps() {
            return {
                name: this.name,
                placeholder: this.placeholder,
            };
        },
        checkboxIconClass() {
            return this.modelValue ? 'material-icons' : 'material-icons-outlined';
        },
        checkboxIcon() {
            return this.modelValue ? 'check_box' : 'check_box_outline_blank';
        },
    },
    watch: {
        value: function (newValue) {
            this.$emit('update-field', {
                name: this.name,
                group: this.group,
                value: newValue,
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
.form-checkbox {
    margin-right: 1rem;
    cursor: pointer;

    input {
        display: none;
    }
    span {
        line-height: 20px;
        color: $primary;
    }
}
</style>
